import { Link, SxProps, Theme } from "@mui/material";
import { MouseEvent, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { buildWasteStreamUrl } from "util/wasteUrls";

/** A click the browser turns into a new tab or window rather than following the link here. */
function isModifiedClick(event: MouseEvent) {
  return event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
}

/**
 * A stream's name that opens its drawer over the current page. The href is
 * still the streams page, so a modified click opens that in a new tab. The
 * click stops here, so a grid row or card holding the link doesn't also act
 * on it.
 */
export function WasteStreamLink({
  tenantId,
  wasteStreamId,
  onOpen,
  noWrap,
  sx,
  children,
}: {
  tenantId: string;
  wasteStreamId: string;
  onOpen: () => void;
  noWrap?: boolean;
  sx?: SxProps<Theme>;
  children: ReactNode;
}) {
  return (
    <Link
      component={RouterLink}
      to={buildWasteStreamUrl(tenantId, wasteStreamId)}
      onClick={(event) => {
        event.stopPropagation();
        if (isModifiedClick(event)) return;
        event.preventDefault();
        onOpen();
      }}
      noWrap={noWrap}
      sx={sx}
    >
      {children}
    </Link>
  );
}
